import LeadRepository from "./LeadRepository";
const repositories = {
  newLead: LeadRepository,
};
export const RepositoryFactory = {
  get: (name) => repositories[name],
};
